import store from '@/store.js'
import Vue from 'vue'
import permissions from '@/util/ACL/permissionMap';

export default function(permission) {

  // Receive permission name as a string parameter
  let client = store.state.client;
  let user = store.state.user;
  let hasPermission = false;

  // If Super admin
  if (user.isAdmin) {
    hasPermission = true;
  } else {
    // If not Super admin
    if (client) {
      // Loop through all user roles
      Vue._.forEach(client.user_permissions, function(userPermission) {

        if(userPermission.name === permission){
          // Set Boolean variable to true if permission is matched
          hasPermission = true;
          return true;
        }
      })
    }
  }

  // Return Boolean if user has given permission
  return hasPermission;
}
